import { Icon } from './lib/icon.js';
import { addDefaultIconsets } from './lib/default-sets.js';
addDefaultIconsets();
customElements.define('cipublic-icon', Icon);
//# sourceMappingURL=cipublic-icon.js.map